<script lang="ts">
    import { theme } from '$theme/theme.svelte';
</script>

<div
    style:padding-left={$theme.gutter}
    style:padding-right={$theme.gutter}
    id="GUTTER"
    {...$$restProps}
>
    <slot />
</div>

<style>
    div {
        max-width: 1440px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
</style>
